var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-template"},[_c('a-row',{staticClass:"row",attrs:{"gutter":[12]}},[_c('a-col',{staticClass:"col",attrs:{"span":6}},[_c('MenuProfile',{attrs:{"itemSelected":_vm.itemSelected}})],1),(_vm.profile && _vm.company)?_c('a-col',{staticClass:"col",attrs:{"span":18}},[_c('router-view')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }